<template>
  <div class="CredMax-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="CredMax-aboutusbox">
      <div class="title">
        <p>Sobre nosotros</p>
        <span> Servicios de préstamos profesionales y personalizados</span>
      </div>
    </div>
    <div class="toOur">
      <div class="left">
        <div class="title">Nuestra APP de préstamos se compromete a brindar a los usuarios la mejor experiencia de
          servicio y garantizar que cada usuario pueda obtener el préstamo que necesita en el menor tiempo posible.
        </div>
        <div class="text">Nuestra aplicación de préstamos se compromete a brindar a los usuarios servicios de préstamos
          eficientes y convenientes. Ya sea consumo personal u operaciones comerciales, podemos brindar soluciones
          personalizadas. Nuestro equipo de atención al cliente está en línea las 24 horas, listo para responder sus
          preguntas y brindar servicios de consultoría profesionales. Además, utilizamos medios técnicos avanzados para
          garantizar la seguridad y transparencia de cada transacción, permitiéndole pedir prestado con confianza.
        </div>
      </div>
      <div class="right">
        <div class="itemBox">
          <div class="item">
            <img src="../assets/aboutUs1.png" alt="">
            <p>Estricta revisión de calificación</p>
            <span>Nuestra plataforma tiene estrictos requisitos de calificación para los prestatarios y un riguroso
              proceso de revisión para garantizar la seguridad y confiabilidad de cada préstamo.</span>
          </div>
          <div class="item">
            <img src="../assets/aboutUs2.png" alt="">
            <p>Préstamo rápido</p>
            <span>El umbral de solicitud es bajo y la velocidad de revisión es rápida. Los usuarios pueden obtener
              préstamos en poco tiempo para satisfacer las necesidades de financiación de emergencia.</span>
          </div>
        </div>
        <div class="itemBox">
          <div class="item">
            <img src="../assets/aboutUs3.png" alt="">
            <p>Diversos métodos de pago</p>
            <span>Proporciona una variedad de métodos de pago, incluidas deducciones automáticas, pagos manuales, etc.,
              para facilitar a los usuarios la gestión flexible de sus finanzas.
            </span>
          </div>
          <div class="item">
            <img src="../assets/aboutUs4.png" alt="">
            <p>Seguro y confiable</p>
            <span>Utilice medios técnicos avanzados para proteger la información del usuario y garantizar la seguridad
              de la información y la protección de la privacidad durante las transacciones.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="best">
      <img src="../assets/aboutUs5.png" alt="">
      <div class="right">
        <div class="title">Confianza del usuario, elección de plataforma formal y de buena reputación</div>
        <div class="text">Ya sean necesidades financieras urgentes o gestión financiera diaria, nuestra plataforma puede
          brindar soporte integral. Además, utilizamos los medios técnicos más avanzados para proteger la información
          del usuario y garantizar la seguridad y protección de la privacidad de cada transacción. No importa cuándo y
          dónde, los usuarios pueden enviar solicitudes de préstamo a través de la aplicación móvil y disfrutar de una
          experiencia de servicio las 24 horas. ¡Elija nuestra APP de préstamos para hacer su gestión financiera más
          fácil y cómoda!</div>
      </div>
    </div>
    <div class="via">
      <div class="left">
        <div class="title">Equipo profesional para garantizar la calidad del servicio.</div>
        <div class="text">Nuestro equipo está formado por expertos financieros experimentados y personal técnico
          superior, dedicados a brindar a los usuarios los servicios de préstamo más profesionales. A través de
          estrictos procesos de revisión interna y medios técnicos avanzados, garantizamos que cada préstamo se someta a
          una estricta evaluación y aprobación de riesgos, garantizando así la seguridad de los fondos de los usuarios.
        </div>
        <div class="itemBox">
          <div class="item" v-for="(item, i) in list" :key="i">
            <div :class="item.val ? 'top' : 'top topa'">
              <p>{{ item.title }}</p>
              <img v-if="item.val" src="../assets/aboutUs6.png" alt="" @click="item.val = !item.val">
              <img v-else src="../assets/aboutUs8.png" alt="" @click="item.val = !item.val">
            </div>
            <div class="info" v-if="item.val">
              <p v-for="(items, y) in item.arr" :key="y">{{ items }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="../assets/aboutUs7.png" alt="">
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      list: [
        {
          val: true,
          title: 'Operación transparente para mejorar la confianza del usuario',
          arr: ['Durante el proceso de operación, nos adherimos a una gestión transparente. Todos los procedimientos de préstamo y los detalles de las tarifas se notificarán a los usuarios con antelación, y se les proporcionarán contratos de préstamo detallados para que los revisen. Este método de operación transparente no solo permite a los usuarios comprender claramente cada transacción, sino que también reduce efectivamente las dudas y preocupaciones de los usuarios.']
        },
        {
          val: false,
          title: 'Garantía de seguridad, proteger los activos de los usuarios.',
          arr: []
        },
        {
          val: false,
          title: 'Equipo profesional, servicio considerado',
          arr: []
        },
      ]
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "projects" });
    }
  },
};
</script>
<style lang="less" scoped>
.CredMax-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 500px;
  background-size: 100% 100%;
  overflow: hidden;

  .title {
    padding: 236px 360px 0;

    p {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 72px;
      color: #2D2D2D;
      line-height: 88px;
    }

    span {
      font-size: 18px;
      color: #4B5257;
      line-height: 28px;
    }
  }
}

.toOur {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 130px 360px;

  .left {
    margin-right: 100px;
    max-width: 530px;

    .title {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 52px;
      color: #2D2D2D;
      line-height: 58px;
    }

    .text {
      font-size: 24px;
      color: #4C4C4C;
      line-height: 28px;
    }
  }

  .right {
    display: flex;

    .itemBox {
      margin-right: 33px;

      .item {
        padding: 44px 14px;
        background: #F2F2F2;
        border-radius: 20px 20px 20px 20px;
        margin-bottom: 30px;
        text-align: center;

        img {
          margin-bottom: 12px;
          width: 60px;
          height: 60px;
        }

        p {
          margin-bottom: 12px;
          font-weight: 500;
          font-size: 24px;
          color: #333333;
          line-height: 36px;
        }

        span {
          font-size: 18px;
          color: #333333;
          line-height: 27px;
        }
      }


      .item:last-child {
        margin-bottom: 0;
      }
    }

    .itemBox:last-child {
      margin-right: 0;
    }

    .itemBox:nth-child(2) {
      padding-top: 80px;
    }
  }
}

.best {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 360px 130px;

  img {
    margin-right: 146px;
    width: 566px;
    height: 502px;
  }

  .right {
    .title {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 52px;
      color: #2D2D2D;
      line-height: 58px;
    }

    .text {
      font-size: 24px;
      color: #4C4C4C;
      line-height: 28px;
    }
  }
}

.via {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 360px 130px;

  .left {
    .title {
      margin-bottom: 24px;
      font-weight: 600;
      font-size: 52px;
      color: #2D2D2D;
      line-height: 58px;
    }

    .text {
      margin-bottom: 42px;
      font-size: 24px;
      color: #4C4C4C;
      line-height: 28px;
    }

    .itemBox {
      width: 500px;

      .topa {
        background: #F1F7FF !important;
      }

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 30px;
        background: #B4CDF6;
        margin-bottom: 18px;

        p {
          font-size: 20px;
          color: #333333;
        }

        img {
          cursor: pointer;
          width: 26px;
          height: 26px;
        }
      }

      .info {
        padding-left: 18px;

        p {
          margin-bottom: 18px;
          font-size: 18px;
          color: #999999;
        }
      }
    }

  }
}
</style>
